
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";




function AppointmentList() {

  const navigate = useNavigate();


  useEffect(() => {
    const scriptUrls = [
      '/assets/js/jquery.min.js',
      '/assets/js/bootstrap.bundle.min.js',
      '/assets/js/moment.min.js',
      '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      '/assets/vendor/overlay-scroll/custom-scrollbar.js',
      '/assets/vendor/daterange/daterange.js',
      '/assets/vendor/daterange/custom-daterange.js',
      '/assets/vendor/jquery-ui/jquery-ui.min.js',
      '/assets/vendor/jquery-ui/custom.js',
      '/assets/vendor/datatables/dataTables.min.js',
      '/assets/vendor/datatables/dataTables.bootstrap.min.js',
      '/assets/vendor/datatables/custom/custom-datatables.js',
      '/assets/js/custom.js',
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleCancel = () => {
    navigate("/appointment-list");
    setTimeout(() => {
      window.location.reload(); // force page refresh after navigation
    }, 100);
  };

  const handleSubmit = () => {
    // Optional: Add form validation logic here
    navigate("/edit-appointment");
    setTimeout(() => {
      window.location.reload(); // force page refresh after navigation
    }, 100);
  }

  useEffect(() => {
    const bootstrapScript = document.createElement('script');
    bootstrapScript.src = '/assets/js/bootstrap.bundle.min.js';

    bootstrapScript.onload = () => {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    };

    document.body.appendChild(bootstrapScript);
  }, []);


  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Appointments</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Appointments List
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="card-title">Applointments List</h5>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Book Appointment
                </button>
              </div>
              <div className="card-body">
                {/* Table starts */}
                <div className="table-responsive">
                  <table id="scrollVertical" className="table m-0 align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Patient Name</th>
                        <th>Age</th>
                        <th>Consulting Doctor</th>
                        <th>Department</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Disease</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>001</td>
                        <td>
                          Deena Cooley
                        </td>
                        <td>65</td>
                        <td>
                          <img src="assets/images/doctor.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Lucia Waller
                        </td>
                        <td>Surgeon</td>
                        <td>05/23/2024</td>
                        <td>9:30AM</td>
                        <td>Diabeties</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accepted">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject" disabled>
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>

                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>002</td>
                        <td>
                          Rhea Barry
                        </td>
                        <td>73</td>
                        <td>
                          <img src="assets/images/doctor1.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Ola Valencia
                        </td>
                        <td>Gynecologist</td>
                        <td>05/23/2024</td>
                        <td>9:45AM</td>
                        <td>Fever</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept" disabled>
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Rejected">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"
                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>

                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>003</td>
                        <td>
                          Willie Moon
                        </td>
                        <td>84</td>
                        <td>
                          <img src="assets/images/doctor2.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Basil Frost
                        </td>
                        <td>Psychiatrists</td>
                        <td>05/23/2024</td>
                        <td>10:00AM</td>
                        <td>Cold</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"
                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>004</td>
                        <td>
                          Jason Compton
                        </td>
                        <td>56</td>
                        <td>
                          <img src="assets/images/doctor4.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Nannie Guerrero
                        </td>
                        <td>Urologist</td>
                        <td>05/23/2024</td>
                        <td>10:15AM</td>
                        <td>Prostate</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>005</td>
                        <td>
                          Emmitt Bryan
                        </td>
                        <td>49</td>
                        <td>
                          <img src="assets/images/doctor5.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Daren Andrade
                        </td>
                        <td>Cardiology</td>
                        <td>05/23/2024</td>
                        <td>10:30AM</td>
                        <td>Asthma</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>006</td>
                        <td>
                          Truman Miles
                        </td>
                        <td>90</td>
                        <td>
                          <img src="assets/images/doctor2.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Colleen Murillo
                        </td>
                        <td>Paediatrician</td>
                        <td>05/23/2024</td>
                        <td>10:45AM</td>
                        <td>Cholera</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>

                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>007</td>
                        <td>
                          Dillon Stokes
                        </td>
                        <td>36</td>
                        <td>
                          <img src="assets/images/doctor3.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Josiah Hobbs
                        </td>
                        <td>Gynecologist</td>
                        <td>05/23/2024</td>
                        <td>11:00AM</td>
                        <td>Heart</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>008</td>
                        <td>
                          Harris Peters
                        </td>
                        <td>79</td>
                        <td>
                          <img src="assets/images/doctor4.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Wilma Dickson
                        </td>
                        <td>Urologist</td>
                        <td>05/23/2024</td>
                        <td>11:15AM</td>
                        <td>Outbreaks</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>

                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>009</td>
                        <td>
                          Tomas Schultz
                        </td>
                        <td>79</td>
                        <td>
                          <img src="assets/images/doctor5.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Monique Merritt
                        </td>
                        <td>Paediatrician</td>
                        <td>05/23/2024</td>
                        <td>11:30AM</td>
                        <td>Fever</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>010</td>
                        <td>
                          Rhea Barry
                        </td>
                        <td>73</td>
                        <td>
                          <img src="assets/images/doctor1.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Ola Valencia
                        </td>
                        <td>Gynecologist</td>
                        <td>05/23/2024</td>
                        <td>9:45AM</td>
                        <td>Fever</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept" disabled>
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Rejected">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>011</td>
                        <td>
                          Willie Moon
                        </td>
                        <td>84</td>
                        <td>
                          <img src="assets/images/doctor2.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Basil Frost
                        </td>
                        <td>Psychiatrists</td>
                        <td>05/23/2024</td>
                        <td>10:00AM</td>
                        <td>Cold</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>012</td>
                        <td>
                          Jason Compton
                        </td>
                        <td>33</td>
                        <td>
                          <img src="assets/images/doctor4.png" className="img-2x rounded-5 me-1" alt="Dental Admin Template" /> Nannie Guerrero
                        </td>
                        <td>Urologist</td>
                        <td>05/23/2024</td>
                        <td>10:15AM</td>
                        <td>Prostate</td>
                        <td>
                          <div className="d-inline-flex gap-1">
                            <button className="btn btn-outline-success btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Accept">
                              <i className="ri-checkbox-circle-line" />
                            </button>
                            <button className="btn btn-outline-danger btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Reject">
                              <i className="ri-close-circle-line" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Appointment"

                              onClick={handleSubmit}
                            >
                              <i className="ri-edit-box-line" />
                            </button>


                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* Table ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>

  )
}
export default AppointmentList